export default class UsersAndAccessController {
    /** @ngInject */
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
        this.tabs = [
            {
                title: 'Users',
                state: 'main.users-and-access.users',
                disabled: true
            },
            {
                title: 'Roles',
                state: 'main.users-and-access.roles',
                disabled: true
            },
            {
                title: 'Customers',
                state: 'main.users-and-access.customers',
                disabled: true
            }
        ];
    }

    onTabClick({ tab }) {
        this.$state.go(tab.state);
    }
}



// WEBPACK FOOTER //
// ./app/components/users-and-access/users-and-access.controller.js